/**
 * Invalidate cookie by setting it's expiration backwards
 */
export default function invalidateCookie(cookie) {
    document.cookie = `${cookie}=;expires=${new Date(0).toUTCString()}`;
}
